module.exports = require('./smooch');



// WEBPACK FOOTER //
// ./src/host/js/npm.js